import React from 'react'
import style from './about.css';
export default function About() {
    return (
        <div class="about-me">
            <h1>Justin Krasner</h1>
            <h4>software engineer</h4>
            <br></br>
            <h6>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolore quos dignissimos neque veniam exercitationem porro itaque quas rem, iste laborum doloribus alias? Autem quis soluta aperiam voluptate cum molestias dolore.</h6>
        </div>
    )
}
